import React from 'react';
import { Link } from 'react-router-dom';
import './Card.component.scss';

export function CardComponent(props: any) {
  return (
    <Link to={props.path} className={`card-container ${props.class}`}>
      <img className='card-image' src={props.img} alt='img' />
      {props.title ? <h4 className='card-h4'>{props.title}</h4> : null}
    </Link>
  );
}
